import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getNoticeDetail, getNoticeList } from '../../lib/api/notice-support-api';
import './NoticePage.css';

function NoticePage() {
  const navigate = useNavigate();
  const { id } = useParams();
  const isDetail = !!id;
  const [notices, setNotices] = useState([]);
  const [selectedNotice, setSelectedNotice] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const load = async () => {
      try {
        if (isDetail) {
          const response = await getNoticeDetail(id);
          setSelectedNotice(response?.data || null);
        } else {
          const response = await getNoticeList();
          setNotices(response?.data || []);
        }
      } catch (err) {
        setError(err.message || (isDetail ? '공지사항 상세를 불러오지 못했습니다.' : '공지사항을 불러오지 못했습니다.'));
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [id, isDetail]);

  const handleBackToList = () => {
    navigate('/notice');
  };

  return (
    <div className="notice-page">
      <div className="notice-content">
        <div className="notice-container">
          <h1>공지사항</h1>

          {loading && <div className="notice-status">불러오는 중입니다...</div>}
          {!!error && <div className="notice-status error">{error}</div>}

          {!loading && !isDetail ? (
            <div className="notice-list">
              <table className="notice-table">
                <thead>
                  <tr>
                    <th className="col-num">번호</th>
                    <th className="col-title">제목</th>
                    <th className="col-date">작성일</th>
                    <th className="col-views">조회수</th>
                  </tr>
                </thead>
                <tbody>
                  {notices.map((notice, index) => (
                    <tr key={notice.id} onClick={() => navigate(`/notice/${notice.id}`)} className="notice-row">
                      <td className="col-num">{notices.length - index}</td>
                      <td className="col-title">{notice.title}</td>
                      <td className="col-date">{notice.date}</td>
                      <td className="col-views">{Number(notice.views || 0).toLocaleString()}</td>
                    </tr>
                  ))}
                  {notices.length === 0 && (
                    <tr>
                      <td className="notice-empty" colSpan={4}>등록된 공지사항이 없습니다.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          ) : null}

          {!loading && isDetail && selectedNotice ? (
            <div className="notice-detail">
              <button onClick={handleBackToList} className="detail-back-top">
                돌아가기
              </button>
              <div className="detail-header">
                <h2>{selectedNotice.title}</h2>
                <div className="detail-meta">
                  <span>작성일: {selectedNotice.date}</span>
                  <span>조회수: {Number(selectedNotice.views || 0).toLocaleString()}</span>
                </div>
              </div>
              <div className="detail-content">{selectedNotice.content}</div>
              <div className="detail-footer">
                <button onClick={handleBackToList} className="back-button">
                  목록으로
                </button>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default NoticePage;
